export default {
	path: '/cctv',
	redirect: '/cctv',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'cctvHome',
			component: () => import('@/views/mng/Cctv'),
		},
	],
};
